import { ChakraComponents as CC } from '../lib/chakra';

type Props = {
  [x: string]: any,
  text?: boolean,
};
export default function AppLoader({ text, ...rest }: Props) {
  return (
    <>
      <CC.Flex justifyContent="center" alignItems="center" h={'100vh'}>
        <CC.Spinner {...rest} />
        <CC.Box ml="2">
          {text !== false && (
            <CC.Text ml="2" fontSize="sm">
              Chargement...
            </CC.Text>
          )}
        </CC.Box>
      </CC.Flex>
    </>
  );
}
